export default __webpack_public_path__ + "static/media/img4.bf5996aa.jpg";